import axios, { AxiosResponse } from 'axios';
import { User, Collection, Article, Media } from './app/types';
import {
    updateArticles,
    updateCollections,
    updateMedia,
    setLoggedInUser,
} from './app/actions';

enum DBAction{
    CreateAction        = 1,
	DeleteAction        = 2,
	RestoreAction       = 3,
	SetNameAction       = 4,
	SetEmailAction      = 5, // string
	SetPasswordAction   = 6, // string
	SetRoleAction       = 7, // int; enumerated above
	SetMediaAction      = 8, // EventData = MediaID
	SetContentAction    = 9, // Content, MimeType
	SetPublishedAction  = 10,
	SetOrderIndexAction = 11,
}

class PublicationsResponse {
    articles: []
    collections: []
    error: string
    success: boolean
}

class NewCollectionResponse {
    collection: Collection
}

class LoginResponse {
    articles: [] // TODO
    collections: [] // TODO
    user: User
    error: string
    success: boolean
}

class ArticleEventResponse {
    article: Article
    event: Object
    success: boolean
    error: string   
}

class CollectionEventResponse {
    collection: Collection
    event: Object
    success: boolean
    error: string   
}

class GetMediaResponse {
    media: []
    success: boolean
    error: string
}

export const getPublications = (dispatch) => {
    axios.get('/api/v1/publications')
        .then((result: AxiosResponse<PublicationsResponse>) => {
        dispatch(updateCollections(result.data.collections));
        dispatch(updateArticles(result.data.articles));
    })
    .catch( err => {
        console.log("get publications err:" + err.message);
    });
};

export const newCollection = (dispatch, name) => {
    return axios.post('/api/v1/collections', {name})
        .then((result: AxiosResponse<NewCollectionResponse>) => {
            let collections: Collection[] = [result.data.collection];
            dispatch(updateCollections(collections as [])); // tuples vs arrays?
            return result.data.collection;
    })
}

export const getMediaForCollection = (dispatch, collectionID) => {
    return axios.get('/api/v1/collection/' + collectionID + '/media')
        .then((result: AxiosResponse<GetMediaResponse>) => {
            let media: Media[] = result.data.media;
            dispatch(updateMedia(media as []));
            return result.data.media;
    })
}

export const login = (dispatch, email, password) => {
    return axios.post('/api/v1/login', {email, password})
        .then((result: AxiosResponse<LoginResponse>) => {
            dispatch(updateCollections(result.data.collections));
            dispatch(updateArticles(result.data.articles));
            dispatch(setLoggedInUser(result.data.user));        
    }).catch( err => {
        console.log(err);
    })
}

export const logout = (dispatch) => {
    return axios.get('/api/v1/logout')
        .then(() => dispatch(setLoggedInUser(null)));
}

export const setArticleName = (dispatch, articleID, content) => {
    return articleEvent(dispatch, articleID, DBAction.SetNameAction, content);
}

export const setArticleContent = (dispatch, articleID, content) => {
    return articleEvent(dispatch, articleID, DBAction.SetContentAction, content);
}

export const setArticleOrderIndex = (dispatch, articleID, value) => {
    return articleEvent(dispatch, articleID, DBAction.SetOrderIndexAction, value.toString());
}

export const setArticlePublished = (dispatch, articleID, value) => {
    return articleEvent(dispatch, articleID, DBAction.SetPublishedAction, value.toString());
}

export const articleEvent = (dispatch, articleID, eventType, payload) => {
    return axios.post('/api/v1/article/'+articleID+'/events', {
        action:eventType,
        eventData: payload
    }).then( (result: AxiosResponse<ArticleEventResponse>) => {
        let articles: Article[] = [result.data.article];
        dispatch(updateArticles(articles as []))
        return result.data.article;
    });
}

export const newArticle = (dispatch, collectionID, name) => {
    return axios.post('/api/v1/articles', {name, collectionID: parseInt(collectionID)})
        .then((result: AxiosResponse<ArticleEventResponse>) => {
            let articles: Article[] = [result.data.article];
            dispatch(updateArticles(articles as []))
            return result.data.article;
        });
}

export const setCollectionName = (dispatch, collectionID, value) => {
    return collectionEvent(dispatch, collectionID, DBAction.SetNameAction, value);
}

export const setCollectionPublished = (dispatch, collectionID, value) => {
    return collectionEvent(dispatch, collectionID, DBAction.SetPublishedAction, value.toString());
}

export const collectionEvent = (dispatch, collectionID, eventType, payload) => {
    return axios.post('/api/v1/collection/'+collectionID+'/events', {
        action:eventType,
        eventData: payload
    }).then( (result: AxiosResponse<CollectionEventResponse>) => {
        let collections: Collection[] = [result.data.collection];
        dispatch(updateCollections(collections as []))
        return result.data.collection;
    });
}